import "./Pricing.css";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Instance from "../../Utils/Axios";
import error from "../../Utils/Icons/error";
import { showToast } from "../../Utils";
import { BuyPrModal } from "../Modal/customModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDollarSign } from "@fortawesome/free-solid-svg-icons";

const PaymentMethodPage = () => {
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [packageDetails, setPackageDetails] = useState(null);
  const [invoiceAmount, setInvoiceAmount] = useState("");
  const { id } = useParams();
  const navigate = useNavigate();
  // const { superPNR } = location.state;

  useEffect(() => {
    const fetchPaymentOptions = () => {
      const token = localStorage.getItem("tokenId");
      const PNR = localStorage.getItem("superPNR");
      Instance.post("/pay/getOption", {
        // tokenId: token,
        superPNR: PNR,
      })
        .then((response) => {
          if (response.data.resCode === "200") {
            const uniqueGateways = Object.values(
              response.data.paymentMethod.reduce((acc, method) => {
                if (!acc[method.gateway]) {
                  acc[method.gateway] = {
                    gateway: method.gateway,
                    code: method.code,
                    options: [],
                  };
                }
                return acc;
              }, {})
            );
            setPaymentMethods(uniqueGateways);
            if (response.data.packageDetails) {
              setPackageDetails(response.data.packageDetails);
            }
            if (response.data.invoiceAmount) {
              setInvoiceAmount(response.data.invoiceAmount);
            }
          } else {
            console.error(
              "Failed to fetch payment options:",
              response.data.resMessage
            );
          }
        })
        .catch((error) => {
          console.error("Error fetching payment options:", error);
          setTimeout(() => {
            navigate(`/customer/pricing/${id}`);
          }, 1000);
        });
    };

    fetchPaymentOptions();
  }, []);

  const handlePaymentMethodChange = (gateway) => {
    setSelectedPaymentMethod(prev => prev === gateway ? null : gateway);
  };

  const handlePurchase = async () => {
    if (!selectedPaymentMethod) {
      showToast("Please select a payment method", "error", "error");
      return;
    }
    setIsLoading(true);
    const token = localStorage.getItem("tokenId");
    const PNR = localStorage.getItem("superPNR");
    const selectedGateway = paymentMethods.find(
      (method) => method.gateway === selectedPaymentMethod
    );

    Instance.post("/pay/paymentRequest", {
      // tokenId: token,
      superPNR: PNR,
      gateway: selectedGateway.gateway,
      paymentMode: selectedGateway.code,
    })
      .then((response) => {
        if (response.data) {
          // const newWindow = window.open();
          document.write(response.data);
          document.close();
        }
      })
      .catch((error) => {
        showToast("Payment Failed! Your transaction could not be processed.", "error", "error");
        setShowErrorModal(true);
        console.error("Payment initiation failed", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className="payment_method_layout">
        <div className="payment_steps">
          <div className="d-flex payment_step_item completed">
            <div className="paymeny_step_img completed_step">
              <img src="/build/greycart.png" alt="Browse Packages" />
            </div>
            <div className="steps_detail">
              <h5>Browse Packages</h5>
              <p>Step 1</p>
            </div>
          </div>
          <div className="d-flex payment_step_item completed">
            <div className="paymeny_step_img completed_step">
              <img src="/build/greytruck.png" alt="Billing Info" />
            </div>
            <div className="steps_detail">
              <h5>Billing Info</h5>
              <p>Step 2</p>
            </div>
          </div>

          <div className="d-flex payment_step_item active">
            <div className="paymeny_step_img active_step">
              <img src="/build/whitecard.png" alt="Payment Methods" />
            </div>
            <div className="steps_detail">
              <h5>Payment Methods</h5>
              <p>Step 3</p>
            </div>
          </div>
          <div className="d-flex payment_step_item">
            <div className="paymeny_step_img">
              <img src="/build/greyaward.png" alt="Confirmation" />
            </div>
            <div className="steps_detail">
              <h5>Confirmation</h5>
              <p>Step 4</p>
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '30px', marginTop: '30px' }}>
          {packageDetails && (
            <div className="checkout_card order_summary_card">
              <h5 className="checkout_card_title">Package Information</h5>

              <div className="summary_row">
                <div>
                  <h6 className="summary_package_name">{packageDetails.packageName || "n/a"}</h6>
                  <small className="summary_package_info d-block mb-1">
                    Package Validity is :- {packageDetails.validity ? `${packageDetails.validity} Days` : "NA"}
                  </small>
                  <small className="summary_package_info d-block">
                    No of credits is :- {packageDetails.pressReleaseCount ?? "NA"}
                  </small>
                </div>
                <div className="summary_price">
                  <span className="currency_symbol"><FontAwesomeIcon icon={faDollarSign} /></span>{packageDetails.price || "0"}
                </div>
              </div>

              <div className="summary_row">
                <span className="summary_label">
                  Discount{" "}
                  {packageDetails.couponCode && (
                    <span className="coupon_code">
                      {packageDetails.couponCode}
                    </span>
                  )}
                </span>

                <span
                  className="summary_discount_value"
                  style={{
                    color:
                      !packageDetails.discountValue ||
                        packageDetails.discountValue === "0"
                        ? "#ef4444"
                        : "#22c55e",
                  }}
                >
                  {packageDetails.discountValue &&
                    packageDetails.discountValue !== "0" ? (
                    <>
                      - <span className="currency_symbol"><FontAwesomeIcon icon={faDollarSign} /></span>
                      {packageDetails.discountValue}
                    </>
                  ) : (
                    "0.00"
                  )}
                </span>
              </div>

              <div className="summary_total_row">
                <span className="summary_total_label">Total to Pay</span>
                <span className="summary_total_value">
                  <span className="currency_symbol"><FontAwesomeIcon icon={faDollarSign} /></span>{invoiceAmount || packageDetails.price || "0"}
                </span>
              </div>
            </div>
          )}

          <div className="checkout_card">
            <h5 className="checkout_card_title no-border">Payment</h5>
            <p className="payment_secure_text">All transactions are secure and encrypted.</p>

            <div className="payment-options-list checkout_options_list">
              {paymentMethods.map((method, index) => (
                <div
                  className={`payment-method-card ${selectedPaymentMethod === method.gateway ? 'selected' : ''}`}
                  key={index}
                  onClick={() => handlePaymentMethodChange(method.gateway)}
                >
                  <input
                    type="radio"
                    checked={selectedPaymentMethod === method.gateway}
                    onChange={() => { }}
                    className="payment-radio"
                  />
                  <img
                    src={
                      method.gateway === "RAZORPAY"
                        ? "/build/razorpaylogo.png"
                        : "/build/paypallogo.png"
                    }
                    alt={method.gateway}
                    className="gateway-logo"
                    width={method.gateway === "RAZORPAY" ? 140 : 110}
                    height={method.gateway === "RAZORPAY" ? 32 : 48}
                  />
                </div>
              ))}
            </div>

            <div className="payment_confirm_btn">
              <button
                className="payment_cancel_btn"
                onClick={() => navigate("/customer/pricing")}
                disabled={isLoading}
              >
                Cancel
              </button>
              <button
                className={`payment_pay_btn ${isLoading ? 'disabled' : ''}`}
                onClick={handlePurchase}
                disabled={isLoading}
              >
                {isLoading ? "Processing..." : "Confirm"}
              </button>
            </div>
          </div>
        </div>
      </div>
      <BuyPrModal
        show={showErrorModal}
        onClose={() => setShowErrorModal(false)}
        onClick={() => {
          setShowErrorModal(false);
          handlePurchase();
        }}
        onSecondaryClick={() => {
          setShowErrorModal(false);
          navigate("/customer/support");
        }}
        title="Payment Failed!"
        message="Oops! Something went wrong with your transaction. Please try again or contact support if the issue persists."
        primaryBtn="Try Again"
        secondaryBtn="Contact Support"
        icon="/build/img/Icons/error.svg"
      />
    </>
  );
};

export default PaymentMethodPage;
